import * as React from 'react';
import { Page, Card, Text } from '@shopify/polaris';
import { ErrorIcon } from 'components/JsxIcons';
import Footer from 'components/Footer';
import t from 'lib/translation';
import styles from './ErrorComponent.module.css';
import { FallbackProps } from 'react-error-boundary';

const ErrorComponent: React.FC<FallbackProps> = ({ error }) => {
  return (
    <>
      <Page>
        <Card>
          <div className={`${styles.container}`}>
            <div className={`${styles.icon}`}>
              <ErrorIcon color="black" />
            </div>
            <Text as="h1" variant="heading2xl">
              {t('components.error.title')}{' '}
            </Text>
            <div className={`${styles.info}`}>
              <Text variant="headingMd" as="h2">
                {t('components.error.message')}
              </Text>
            </div>
            <div className={`${styles.info}`}>
              <Text variant="headingMd" as="h2">
                {t('components.error.technicalDetails')}
              </Text>
            </div>
            <pre>{error?.message}</pre>
          </div>
        </Card>
      </Page>
      <Footer />
    </>
  );
};

export default ErrorComponent;
